// extracted by mini-css-extract-plugin
export default {"page-intro":"PageIntro_page-intro__lKEbm","page-intro__sub":"PageIntro_page-intro__sub__EWP-p","page-intro__main":"PageIntro_page-intro__main__7k0zR"};